import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Required from '../utils/required';

import Home from '../views/Home.vue';
import Login from '../views/Auth/Login.vue';

import IndexProfile from '../views/Profile/Index.vue';
import FormProfile from '../views/Profile/Form.vue';

import IndexUser from '../views/User/Index.vue';
import FormUser from '../views/User/Form.vue';

const required = new Required();

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/login',
    name: 'Default Route'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    beforeEnter: required.requireAuth
  },
  {
    path: '/profiles',
    name: 'IndexProfile',
    meta: {
      parent: 'Management',
      create: 'Profile',
      edit: 'Profile',
      title: 'Profiles'
    },
    component: IndexProfile,
    beforeEnter: required.requireAuth
  },
  {
    path: '/profile/:id?',
    name: 'FormProfile',
    meta: {
      parent: 'Management',
      before: 'IndexProfile',
      index: 'profiles',
      title: 'Profile'
    },
    component: FormProfile,
    beforeEnter: required.requireAuth
  },
  {
    path: '/users',
    name: 'IndexUser',
    meta: {
      parent: 'Management',
      create: 'User',
      edit: 'User',
      title: 'Users'
    },
    component: IndexUser,
    beforeEnter: required.requireAuth
  },
  {
    path: '/user/:id?',
    name: 'FormUser',
    meta: {
      parent: 'Management',
      before: 'IndexUser',
      index: 'users',
      title: 'User'
    },
    component: FormUser,
    beforeEnter: required.requireAuth
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
